import { FrameStackIcon, IconBox } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

export const RelatedIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return (
    <IconBox color="green" icon={<FrameStackIcon />} size={size} {...props} />
  );
};
